/**
 * useStudentHomeStoreReview — la demande de note sur le store, à l'arrivée sur l'accueil de
 * l'élève. Port de `promptStoreReviewIsApplicable` (`TodoListScreen.js:104-148`) :
 *
 * hors web, quand le store sait demander une note, que l'élève a fait au moins une activité, et
 * qu'on ne la lui a pas encore demandée pour cette version de l'app, la demande part deux secondes
 * après l'arrivée sur l'onglet — et pas si l'élève l'a quitté entre-temps.
 */
import { useFocusEffect } from "@react-navigation/native"
import Constants from "expo-constants"
import * as StoreReview from "expo-store-review"
import { useCallback } from "react"
import { Platform } from "react-native"

import {
    getActivitiesCount,
    getLastVersionPromptedForReview,
    setLastVersionPromptedForReview,
} from "../../../../../../data/utility/asyncStorageUtils"

const PROMPT_DELAY_MS = 2000

async function storeReviewApplies(): Promise<boolean> {
    if (!(await StoreReview.isAvailableAsync()) || !(await StoreReview.hasAction())) return false
    if ((await getActivitiesCount()) < 1) return false
    return (await getLastVersionPromptedForReview()) !== Constants.expoConfig?.version
}

export function useStudentHomeStoreReview() {
    useFocusEffect(
        useCallback(() => {
            if (Platform.OS === "web") return
            let active = true
            let timer: ReturnType<typeof setTimeout> | undefined
            void storeReviewApplies().then((applies) => {
                if (!applies || !active) return
                timer = setTimeout(() => {
                    if (!active) return
                    void setLastVersionPromptedForReview()
                    StoreReview.requestReview().catch((error: unknown) => console.error("error", error))
                }, PROMPT_DELAY_MS)
            })
            return () => {
                active = false
                if (timer != null) clearTimeout(timer)
            }
        }, [])
    )
}
